import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import BoundaryService from "../services/BoundaryService";

const useBoundaryService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new BoundaryService(client);
  }, [client]);

  return service;
};

export default useBoundaryService;
